import {CONCERN} from "../../constants/concern";

export function fetchConcern(params) {
    return {
        type: CONCERN.FETCH_CONCERN.MAIN,
        params
    }
}

